import { IFontFamily } from '../../../shared/contexts/styleContext';

export const FontFamily: IFontFamily = {
    default: 'Arial, Helvetica, sans-serif'
};
